import { gql } from "@apollo/client";

export const get_orders = gql`
  query Orders(
    $where: OrderWhereInput
    $orderBy: [OrderOrderByWithRelationInput!]
    $take: Int
  ) {
    orders(where: $where, orderBy: $orderBy, take: $take) {
      id
      discount
      net_total
      order_id
      status
      total
      clinic_id
      created_at
      payment_method
      payment_status
      credit_balance
      balance
      tax
      member_id
      member {
        name
        id
      }
      user_id
      user {
        id
        name
      }
    }
  }
`;

export const get_orders2 = gql`
  query Orders(
    $where: OrderWhereInput
    $orderBy: [OrderOrderByWithRelationInput!]
    $take: Int
    $skip: Int
    $clinicMembersWhere2: ClinicMemberWhereInput
  ) {
    orders(where: $where, orderBy: $orderBy, take: $take, skip: $skip) {
      id
      discount
      net_total
      order_id
      status
      total
      clinic_id
      created_at
      payment_method
      payment_status
      credit_balance
      balance
      tax
      member_id
      member {
        name
        id
        clinic_members(where: $clinicMembersWhere2) {
          name
          clinic_id
        }
      }
      user_id
      user {
        id
        name
      }
      seller {
        display_name
      }
      metadata
      referral_name
      payments {
        id
        payment_amount
      }
    }
  }
`;

export const get_slim_orders = gql`
  query Orders(
    $where: OrderWhereInput
    $orderBy: [OrderOrderByWithRelationInput!]
    $take: Int
  ) {
    orders(where: $where, orderBy: $orderBy, take: $take) {
      id
      total
      created_at
    }
  }
`;

export const getOrdersVar = (data: {
  clinicId: string;
  startDate: Date;
  endDate: Date;
  status?: string[];
  searchText?: string | null;
  take: number;
  notUserIds?: string[];
}) => {
  const { status = [], searchText } = data;
  let variables: any = {},
    where: any = {},
    OR: any[] = [];
  if (searchText && searchText !== "") {
    OR.push({
      member: {
        is: {
          OR: [
            { name: { contains: searchText } },
            { phonenumber: { contains: searchText } },
          ],
        },
      },
    });
    OR.push({ user: { is: { OR: [{ name: { contains: searchText } }] } } });
    OR.push({ order_id: { contains: searchText } });
  }
  where.clinic_id = { equals: data.clinicId };
  where.created_at = { gte: data.startDate, lte: data.endDate };
  if (data.notUserIds && data.notUserIds.length > 0) {
    where.user_id = { notIn: data.notUserIds };
  }
  if (status.length > 0) where.status = { in: status };
  if (OR.length > 0) where.OR = OR;
  variables.where = where;
  variables.orderBy = [{ created_at: "desc" }];
  variables.take = data.take;
  return variables;
};
export const getOrdersVar2 = (data: {
  clinicId: string;
  startDate: Date;
  endDate: Date;
  status?: string[];
  payment_status: string[];
  searchText?: string | null;
  take: number;
  notUserIds?: string[];
  skip?: number;
  sellerId?: string;
  referralInclude?: boolean;
}) => {
  const { status = [], searchText, skip = 0 } = data;
  const { payment_status = [] } = data;
  let variables: any = {},
    where: any = {},
    OR: any[] = [];
  if (searchText && searchText !== "") {
    OR.push({
      member: {
        is: {
          OR: [
            { name: { contains: searchText } },
            { phonenumber: { contains: searchText } },
          ],
        },
      },
    });
    OR.push({ user: { is: { OR: [{ name: { contains: searchText } }] } } });
    OR.push({ order_id: { contains: searchText } });
  }
  where.clinic_id = { equals: data.clinicId };
  where.created_at = { gte: data.startDate, lte: data.endDate };
  if (data.notUserIds && data.notUserIds.length > 0) {
    where.user_id = { notIn: data.notUserIds };
  }
  if (data.sellerId != null) {
    where.seller_id = { equals: data.sellerId };
  }
  if (status.length > 0) where.status = { in: status };
  if (payment_status.length > 0) where.payment_status = { in: payment_status };
  if (data.referralInclude) {
    where.referral_id = { not: null };
    where.referral_name = { not: null };
  }
  if (OR.length > 0) where.OR = OR;
  variables.where = where;
  variables.clinicMembersWhere2 = { clinic_id: { equals: data.clinicId } };
  variables.orderBy = [{ created_at: "desc" }];
  variables.take = data.take;
  variables.skip = skip;
  return variables;
};

export const get_total_order_count = gql`
  query _count($where: OrderWhereInput) {
    aggregateOrder(where: $where) {
      _count {
        id
      }
    }
  }
`;

export const getTotalOrderCountVar = (args: {
  clinicId: string;
  startDate: Date;
  endDate: Date;
  status?: string[];
  searchText?: string | null;
  notUserIds?: string[];
}) => {
  const { status = [], searchText } = args;
  let variables: any = {},
    where: any = {},
    OR: any[] = [];
  if (searchText && searchText !== "") {
    OR.push({
      member: {
        is: {
          OR: [
            { name: { contains: searchText } },
            { phonenumber: { contains: searchText } },
          ],
        },
      },
    });
    OR.push({ user: { is: { OR: [{ name: { contains: searchText } }] } } });
    OR.push({ order_id: { contains: searchText } });
  }
  where.clinic_id = { equals: args.clinicId };
  where.created_at = { gte: args.startDate, lte: args.endDate };
  if (args.notUserIds && args.notUserIds.length > 0) {
    where.user_id = { notIn: args.notUserIds };
  }
  if (status.length > 0) where.status = { in: status };
  if (OR.length > 0) where.OR = OR;
  variables.where = where;
  return variables;
};
export const get_members_order_count = gql`
  query _count($by: [OrderScalarFieldEnum!]!, $where: OrderWhereInput) {
    groupByOrder(by: $by, where: $where) {
      _count {
        _all
      }
      member_id
      clinic_id
    }
  }
`;
export const getMembersOrderCountVar = (data: {
  clinicId: string;
  memberIds?: string[];
  startDate: Date;
  endDate: Date;
}) => {
  let variables: any = {};
  variables.by = ["clinic_id", "member_id"];
  variables.where = {
    clinic_id: { equals: data.clinicId },
    created_at: { gte: data.startDate, lte: data.endDate },
    ...(data.memberIds ? { member_id: { in: data.memberIds } } : {}),
  };
  return variables;
};

export const get_one_order = gql`
  query GetOrder(
    $where: OrderWhereUniqueInput!
    $clinicMembersWhere2: ClinicMemberWhereInput
  ) {
    getOrder(where: $where) {
      id
      order_id
      total
      tax
      member_id
      status
      payment_method
      payment_detail
      net_total
      discount
      metadata
      created_at
      user_id
      user {
        name
        id
      }
      member {
        id
        name
        clinic_members(where: $clinicMembersWhere2) {
          name
          clinic_id
        }
      }
      clinic {
        id
        name
      }
      order_items {
        id
        quantity
        total
        tax
        price
        original_price
        service_id
        service {
          id
          name
          image
        }
        service_package_id
        service_package {
          id
          name
          image
        }
        product_stock_item_id
        product_stock_item {
          name
          id
        }
        metadata
      }
      seller {
        display_name
      }
      payments {
        payment_amount
        payment_method
      }
    }
  }
`;

export const getOneOrderVar = (id: string, clinicId: string) => ({
  where: { id },
  clinicMembersWhere2: { clinic_id: { equals: clinicId } },
});

export const cancel_order = gql`
  mutation FallbackSaleOrder($orderId: String!, $userId: String!) {
    fallbackSaleOrder(order_id: $orderId, user_id: $userId) {
      id
    }
  }
`;

export const getCancelOrderVar = (data: {
  orderId: string;
  userId: string;
}) => ({ ...data });

export const order_summary = gql`
  query OrderSummary(
    $sellers: [String!]!
    $fromDate: DateTime!
    $toDate: DateTime!
    $status: [String!]!
    $paymentStatus: [String!]!
  ) {
    orderSummary(
      sellers: $sellers
      from_date: $fromDate
      to_date: $toDate
      status: $status
      payment_status: $paymentStatus
    ) {
      total_records
      total_net_amount
      total_balance
      total_credit_balance
      payment_status
      seller_id
    }
  }
`;

export const getOrderSummaryVar = (data: {
  sellers: string[];
  fromDate: Date;
  toDate: Date;
  status: Array<"ACTIVE" | "INACTIVE" | "CANCEL" | "DONE">;
  paymentStatus: Array<"PAID" | "UNPAID" | "PARTIAL_PAID">;
}) => {
  const variable = {
    sellers: data.sellers,
    fromDate: data.fromDate,
    toDate: data.toDate,
    status: data.status,
    paymentStatus: data.paymentStatus,
  };
  return variable;
};

export const archive_order = gql`
  mutation UpdateOneOrder(
    $data: OrderUpdateInput!
    $where: OrderWhereUniqueInput!
    $createOneSystemLogData2: SystemLogCreateInput!
  ) {
    updateOneOrder(data: $data, where: $where) {
      id
    }
    createOneSystemLog(data: $createOneSystemLogData2) {
      id
    }
  }
`;

export const getArchiveOrderVar = (data: {
  orderId: string;
  log: {
    code: string;
    log_id: string;
    metadata: any;
    user: any;
    log_type: string;
  };
}) => ({
  data: {
    status: {
      set: "CANCEL",
    },
  },
  where: {
    id: data.orderId,
  },
  createOneSystemLogData2: { ...data.log },
});

export const get_order_item_list = gql`
  query OrderItems($where: OrderItemWhereInput) {
    orderItems(where: $where) {
      id
      quantity
      price
      total
      original_price
      metadata
      order_id
      practitioner {
        id
        name
      }
      member_service_package {
        id
        service_package_id
        service_package {
          name
        }
      }
      product_stock_item {
        id
        name
      }
      service {
        id
        name
      }
      service_package {
        id
        name
      }
    }
  }
`;

export const getOrderItemListVar = (data: { ids: string[] }) => {
  const variables: any = {
    where: {
      order_id: {
        in: data.ids,
      },
    },
  };
  return variables;
};

export const get_order_items_for_checkins = gql`
  query OrderItems($where: OrderItemWhereInput, $orderBy: [OrderItemOrderByWithRelationInput!]) {
    orderItems(where: $where, orderBy: $orderBy) {
      id
      price
      total
      service_id
      order_id
    }
  }
`;

export const getOrderItemsForCheckinsVar = (data: { orderIds: string[] }) => {
  const variables: any = {
    where: {
      order_id: {
        in: data.orderIds,
      },
      service_id: {
        not: null,
      },
    },
    orderBy: [{id: "asc" }],
  };
  return variables;
};

export const get_sales_detail = gql`
  query GetSalesDetail(
    $clinicCode: String!
    $startDate: DateTime!
    $endDate: DateTime!
    $skip: Int
    $take: Int
  ) {
    getSalesDetail(
      clinicCode: $clinicCode
      startDate: $startDate
      endDate: $endDate
      skip: $skip
      take: $take
    ) {
      data {
        Date
        InvoiceNumber
        CustomerName
        MemberId
        SalePerson
        ServiceName
        ServicePackageName
        WalletTopUp
        PaymentStatus
        InvoiceNetTotal
        ItemQuantity
        ItemPrice
        ItemTotal
        SubTotal
        Total
        NetTotal
        OrderBalance
        OrderCreditBalance
        Discount
        Tax
        PaymentMethod
        PaymentType
        PaymentAmount
        PaymentNote
      }
      totalCount
    }
  }
`;

export const getSalesDetailVar = (data: {
  clinicCode: string;
  startDate: Date;
  endDate: Date;
  skip?: number;
  take?: number;
}) => {
  const variables: any = {
    clinicCode: data.clinicCode,
    startDate: data.startDate,
    endDate: data.endDate,
    skip: data.skip ?? 0,
    take: data.take ?? 20,
  };

  return variables;
};

export const get_payment_report = gql`
  query GetPaymentReport(
    $clinicCode: String!
    $filterType: String!
    $startDate: DateTime
    $endDate: DateTime
    $selectedDate: DateTime
    $skip: Int
    $take: Int
  ) {
    getPaymentReport(
      clinicCode: $clinicCode
      filterType: $filterType
      startDate: $startDate
      endDate: $endDate
      selectedDate: $selectedDate
      skip: $skip
      take: $take
    ) {
      data {
        Date
        InvoiceNumber
        CustomerName
        MemberId
        SalePerson
        ServiceName
        ServicePackageName
        PaymentMethod
        OrderPaymentMethod
        PaymentAmount
        OrderNetTotal
        PaymentStatus
        WalletTopUp
        InvoiceNetTotal
      }
      totalCount
    }
  }
`;

export const getPaymentReportVar = (data: {
  clinicCode: string;
  filterType: "day" | "month";
  startDate?: Date;
  endDate?: Date;
  selectedDate?: Date;
  skip?: number;
  take?: number;
}) => {
  const variables: any = {
    clinicCode: data.clinicCode,
    filterType: data.filterType,
    skip: data.skip ?? 0,
    take: data.take ?? 20,
  };

  if (data.filterType === "day") {
    if (data.startDate) {
      variables.startDate = data.startDate;
    }
    if (data.endDate) {
      variables.endDate = data.endDate;
    }
  } else if (data.filterType === "month") {
    if (data.selectedDate) {
      variables.selectedDate = data.selectedDate;
    }
  }

  return variables;
};

export const get_sales_by_sales_person = gql`
  query GetSalesBySalesPerson(
    $clinicCode: String!
    $startDate: DateTime!
    $endDate: DateTime!
    $skip: Int
    $take: Int
  ) {
    getSalesBySalesPerson(
      clinicCode: $clinicCode
      startDate: $startDate
      endDate: $endDate
      skip: $skip
      take: $take
    ) {
      data {
        Date
        InvoiceNumber
        CustomerName
        CustomerPhoneNumber
        ServiceName
        ServicePackageName
        PaymentMethod
        OrderPaymentMethod
        PaymentStatus
        InvoiceNetTotal
        PaymentAmount
        SellerName
      }
      totalCount
    }
  }
`;

export const getSalesBySalesPersonVar = (data: {
  clinicCode: string;
  startDate: Date;
  endDate: Date;
  skip?: number;
  take?: number;
}) => {
  const variables: any = {
    clinicCode: data.clinicCode,
    startDate: data.startDate,
    endDate: data.endDate,
    skip: data.skip ?? 0,
    take: data.take ?? 20,
  };

  return variables;
};

export const get_sales_by_sales_person_summary = gql`
  query GetSalesBySalesPersonSummary(
    $clinicCode: String!
    $startDate: DateTime!
    $endDate: DateTime!
  ) {
    getSalesBySalesPersonSummary(
      clinicCode: $clinicCode
      startDate: $startDate
      endDate: $endDate
    ) {
      data {
        SellerName
        rowCount
        total
      }
    }
  }
`;

export const getSalesBySalesPersonSummaryVar = (data: {
  clinicCode: string;
  startDate: Date;
  endDate: Date;
}) => ({
  clinicCode: data.clinicCode,
  startDate: data.startDate,
  endDate: data.endDate,
});

export const get_customer_by_salesperson = gql`
  query GetCustomerBySalesPerson(
    $clinicCode: String!
    $sellerId: String!
    $skip: Int
    $take: Int
  ) {
    getCustomerBySalesPerson(
      clinicCode: $clinicCode
      sellerId: $sellerId
      skip: $skip
      take: $take
    ) {
      data {
        name
        phoneNumber
        memberId
        totalSpend
        lastInvoiceNumber
        lastPurchaseDate
      }
      totalCount
    }
  }
`;

export const getCustomerBySalesPersonVar = (data: {
  clinicCode: string;
  sellerId: string;
  skip?: number;
  take?: number;
}) => {
  const variables: any = {
    clinicCode: data.clinicCode,
    sellerId: data.sellerId,
    skip: data.skip ?? 0,
    take: data.take ?? 20,
  };

  return variables;
};
